import { ReturnedAction } from '../reduxTypes';
import { ConfigData } from '../../types';

export const setConfig = (value: ConfigData): ReturnedAction => ({
  type: 'SET_CONFIG',
  value
});
